<template>
  <div>
    <input
      id="__ncm_input_cpf"
      type="text"
      class="form-control"
      v-bind:placeholder="placeholder"
      v-bind:disabled="disabled"
      autocomplete="off"
      @keydown.enter="onEnter"
      @keydown="onKeyDown"
      @keyup="onKeyUp"
      :value="currentValue"
    />
    <span v-bind:class="icon"></span>
  </div>
</template>
<script type="text/javascript">
export default {
  props: ['value', 'placeholder', 'icon', 'disabled'],
  data() {
    return {
      currentValue: ''
    }
  },
  mounted() {
    this.mask(this.value)
  },
  methods: {
    mask(value) {
      this.currentValue = value.replace(/[^0-9]+/g, '')
      if (this.currentValue.length > 3) {
        this.currentValue = `${this.currentValue.substring(0, 3)}.${this.currentValue.substring(3)}`
      }
      if (this.currentValue.length > 7) {
        this.currentValue = `${this.currentValue.substring(0, 7)}.${this.currentValue.substring(7)}`
      }
      if (this.currentValue.length > 11) {
        this.currentValue = `${this.currentValue.substring(0, 11)}-${this.currentValue.substring(
          11
        )}`
      }
      if (this.currentValue.length >= 14) {
        this.currentValue = this.currentValue.substring(0, 14)
      }
      this.$emit('input', this.valueUnmasked)
    },
    onKeyUp(event) {
      this.mask(event.target.value)
    },
    onKeyDown(e) {
      if (e.target.value.length === 14) {
        if (e.keyCode !== 8 && e.keyCode !== 9) {
          e.preventDefault()
        }
      }
    },
    onEnter() {
      this.$emit('on-enter')
    }
  },
  computed: {
    valueUnmasked() {
      return this.currentValue.replace(/[^0-9]+/g, '')
    }
  },
  watch: {
    value(vl) {
      if (vl) {
        this.currentValue = vl
        this.mask(vl)
      } else {
        this.currentValue = ''
      }
    }
  }
}
</script>
